
import {Component, Input} from '@angular/core';

export enum MESSAGE_TYPES {
  PRIMARY = 'primary',
  WARNING = 'warning',
  DANGER = 'danger',
}


@Component({
  selector: 'beaconstac-message',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent {

  /**
   * Type of message (colour)
   */
  @Input()
  type: MESSAGE_TYPES = MESSAGE_TYPES.PRIMARY;

  /**
   * Message string
   */
  @Input()
  message: string;

  @Input()
  icon: string = 'fa-info-circle';

  @Input()
  addContent: boolean = true;


}
